import { type ReactNode, useState } from 'react';
import { DocumentContext } from '@/app/contexts/documentContext.ts';
import type { ComplianceDocument } from '@/app/types';

type DocumentsProviderProps = {
  children: ReactNode;
};

export const DocumentsProvider = ({ children }: DocumentsProviderProps) => {
  const [documentsCP, setDocuments] = useState<ComplianceDocument[]>([]);
  const [currentDocument, setCurrent] = useState<ComplianceDocument>();

  return (
    <DocumentContext.Provider
      value={{ documentsCP, currentDocument, setCurrent, setDocuments }}
    >
      {children}
    </DocumentContext.Provider>
  );
};
